export class Zone {
    public object: Phaser.GameObjects.Image;
    public name: string;
    public rect: Phaser.Geom.Rectangle;
    public placed: boolean;
   
    constructor(zone: Phaser.GameObjects.Image, name: string, rect: Phaser.Geom.Rectangle, placed: boolean) {
        this.object = zone;
        this.name = name;
        this.rect = rect;
        this.placed = placed;
    }
}



// WEBPACK FOOTER //
// ./src/games/LandscapingGame/objects/Zone.ts